import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: {}
};

export const chatsSlice = createSlice({
  name: 'chats',
  initialState,
  reducers: {
    setTyping: (state, action)=> {
      if(!state.list[action.payload._id]) return;
      state.list[action.payload._id].typing = action.payload.typing;
    },
    setChats: (state, action)=> {
      state.list[action.payload._id] = {
        typing: false
      };
    }
  }
});

export const {
  setTyping,
  setChats,
} = chatsSlice.actions;

export default chatsSlice.reducer;
